import { Link, usePage } from '@inertiajs/react'
import { cn } from '@/lib/utils'
import { tabsListVariants, tabsTriggerVariants } from '@/components/ui/Tabs'
import { useMarket } from '@/lib/useMarket'
import {
  plan_bottom_up_by_day_index_path,
  plan_bottom_up_by_month_index_path,
  plan_index_path,
  plan_product_pricings_index_path,
  wholesale_forecast_by_account_path,
} from '@/lib/routes'

// Page-level nav across the planning pages, the same pages as the Menu's
// Planning column. URL-driven (Inertia Links), styled via the ui/Tabs
// "segmented" variant so it matches the review page switcher. Wholesale
// Forecast only for a market with a wholesale channel.
export default function PlanTabs({ className }: { className?: string }) {
  const { url, props } = usePage<{ wholesale_market_ids?: string[] }>()
  const market = useMarket()
  const tabs = [
    { label: 'Top Down', href: plan_index_path(market.slug) },
    { label: 'Products & Pricings', href: plan_product_pricings_index_path(market.slug) },
    { label: 'By Month', href: plan_bottom_up_by_month_index_path(market.slug) },
    { label: 'By Day', href: plan_bottom_up_by_day_index_path(market.slug) },
    ...((props.wholesale_market_ids ?? []).includes(market.id)
      ? [{ label: 'Wholesale Forecast', href: wholesale_forecast_by_account_path(market.slug) }]
      : []),
  ]
  return (
    <nav aria-label="Planning" className={cn(tabsListVariants({ variant: 'segmented' }), className)}>
      {tabs.map((tab) => {
        const active = url.startsWith(tab.href)
        return (
          <Link
            key={tab.href}
            href={tab.href}
            aria-current={active ? 'page' : undefined}
            data-state={active ? 'active' : 'inactive'}
            className={cn(tabsTriggerVariants({ variant: 'segmented' }))}
          >
            {tab.label}
          </Link>
        )
      })}
    </nav>
  )
}
